(function ($, Drupal) {
  Drupal.behaviors.home = {
    attach: function () {
      $("body")
        .once("whatsapp_btn")
        .each(function () {
          const whatsappBubble = new Image();
          whatsappBubble.src =
            "/themes/custom/ensa_servicios/images/icons/whatsapp-bubble.png";
          whatsappBubble.style.position = "fixed";
          whatsappBubble.style.bottom = "20px";
          whatsappBubble.style.right = "20px";
          whatsappBubble.style.width = "62px";
          whatsappBubble.style.height = "62px";
          whatsappBubble.style.borderRadius = "40px";
          whatsappBubble.style.zIndex = "1000";
          whatsappBubble.style.cursor = "pointer";
          whatsappBubble.addEventListener("click", function () {
            window.open(
              "https://api.whatsapp.com/send?phone=64823889&text=Hola!%20Quiero%20contactar%20a%20Ensa%20Servicios",
              "_blank"
            );
          });
          document.body.appendChild(whatsappBubble);
        });
    },
  };
})(jQuery, Drupal);
